<template>
    <v-card class="send-back-reason-dialog custom-dailog">
        <v-card-title>
            {{ chapterWaiverConstants.REASON_HEADER }}
            <i class="fas fa-times" @click="closeDialog()" data-qe-id="closeReasonDialogBoxIcon"></i>
        </v-card-title>
        <v-card-text>
            <v-layout row wrap>
                <v-flex xs9 class="send-back-reason-dialog__error">
                    <v-flex v-if="showError">{{ chapterWaiverConstants.ERROR_OCCURRED }}</v-flex>
                </v-flex>
                <v-flex
                    text-xs-right
                    xs3
                    data-qe-id="reasonTextLength">
                    {{ reasonText.length }} {{ validationText }}
                </v-flex>
            </v-layout>

            <v-textarea
                :disabled="updateInProgress"
                data-qe-id="SendBackReasonText"
                @paste="isPasted($event)"
                v-model="reasonText"
                @keypress="textCountLimiter($event, reasonText, waiverFormConstants.MAX_REASON_LENGTH)">
            </v-textarea>
        </v-card-text>
        <v-card-actions>
            <v-flex text-xs-right class="pt-2 pb-2 pl-1 pr-3">
                <v-btn
                    :disabled="updateInProgress"
                    data-qe-id="cancelReasonDialogBoxBtn"
                    class="primary_btn transparent small"
                    @click="closeDialog()">{{ actionConstants.CANCEL }}</v-btn>
                <v-btn
                    :disabled="disableUpdate"
                    :loading="updateInProgress"
                    data-qe-id="sendBackConfirmBtn"
                    class="primary_btn small"
                    @click="saveAsDraft(prospect), SendBackToChapterUpdate()">{{ actionConstants.CONFIRM_SEND }}</v-btn>
            </v-flex>
        </v-card-actions>
    </v-card>
</template>

<script>
    import { appCommonConstants } from "../appCommon.constants";
    import {
        chapterWaiverConstants,
        waiverFormConstants,
        waiverFormTypesConstants,
        actionConstants,
    } from "./ChapterWaiver.constants";
    import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
    import { storeAction } from "../../store/storeActions.constant";
    import { storeGetters } from "../../store/storeGetters.constant";
    import { storeMutation } from "../../store/storeMutations.constant";
    import { textCountLimiter } from "../../common/utils/utils";

    export default {
        name: 'SendBackReasonDialog',
        created() {
            this.reasonText = '';
        },
        data: () => {
            return {
                appCommonConstants,
                waiverFormTypesConstants,
                chapterWaiverConstants,
                waiverFormConstants,
                showWaiver: false,
                actionConstants,
                reasonText: '',
                showError: false,
                updateInProgress: false,
                disableCancelBtn: false,
                disableReasonTextField: false,
            };
        },
        props: {
            leadId: {
                type: String,
                required: true,
            },
            closeDialogBox: {
                type: Function,
                required: true,
            },
            saveAsDraft: {
                type: Function,
                required: true,
            },
            prospect: {
                type: Object,
                required: true,
            },
        },
        methods: {
            textCountLimiter,

            isPasted($event) {
                const text = $event.clipboardData.getData("text");
                if (this.reasonText.length + text.length > this.waiverFormConstants.MAX_REASON_LENGTH) {
                    $event.preventDefault();
                    return true;
                }
            },

            async SendBackToChapterUpdate() {
                this.updateInProgress = true;
                const req = {
                    reasonText: this.reasonText,
                    leadId: this.leadId,
                };
                await this.sendWaiverBackToChapterOfficer(req);
                this.showError = this.errorOccurred;
                if (this.errorOccurred) {
                    setTimeout(() => {
                        this.showError = false;
                    }, 3000);
                }
                this.resetReasonText();
                this.updateInProgress = false;
                if (this.waiverSentBackToChapter) {
                    this.closeDialog();
                    this.setStatusAfterSentBackToChapter(this.waiverDetails && this.waiverDetails.id === req.leadId ? null : req.leadId);
                    this.setVisibleProspect(null);
                }
            },

            ...mapActions({
                sendWaiverBackToChapterOfficer: `chapterWaiver/${storeAction.sendWaiverBackToChapterOfficer}`,
            }),
            ...mapMutations({
                setStatusAfterSentBackToChapter: `chapterWaiver/${[storeMutation.setStatusAfterSentBackToChapter]}`,
                setVisibleProspect: `chapterWaiver/${storeMutation.setVisibleProspect}`,
            }),
            resetReasonText() {
                this.reasonText = '';
            },
            closeDialog() {
                this.resetReasonText();
                this.closeDialogBox();
            },
        },
        computed: {
            ...mapState("actionState", ["actions"]),
            ...mapGetters({
                waiverSentBackToChapter: `chapterWaiver/${storeGetters.waiverSentBackToChapter}`,
                errorOccurred: `chapterWaiver/${storeGetters.sentBackErrorOccurred}`,
                waiverDetails: `chapterWaiver/${storeGetters.waiverDetails}`,
            }),

            validationText() {
                return `${this.waiverFormConstants.OF} ${this.waiverFormConstants.MAX_REASON_LENGTH} ${this.waiverFormConstants.CHARACTERS}`;
            },

            disableUpdate() {
                const reason = this.reasonText.trim();
                return this.reasonText.length <= 0 || reason === "";
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import "../../common/styles/_colors.scss";
    @import "../../common/styles/_commonClasses.scss";

    .error {
        color: $ypo-deep-red;
    }

    .send-back-reason-dialog {
        &.custom-dailog {

            .v-card {
                &__text {
                    margin: 0px;
                    padding: 16px 16px 16px 16px;
                }
            }

            .v-card__title {
                color: $white;
                background: $ypo-blue;
                font-size: 19px;

                i {
                    color: $white;
                    padding: 2px 2px 0px 25px;
                    cursor: pointer;
                }
            }
            
        }

        &__error {
            color: $ypo-deep-red;
        }
    }
</style><style lang="scss">
    @import "../../common/styles/_colors.scss";

    .send-back-reason-dialog {

        .v-input__slot:before,
        .v-input__slot:after {
            display: none;
        }

        .v-text-field {
            padding: 0px;
            margin: 0px;
        }

        textarea {
            border: 1px solid $ypo-medium-gray;
            border-radius: 3px;
            color: $ypo-blue !important;
            padding: 10px 10px;
            font-size: 14px;
            transition: 0.3s all ease;

            &:focus {
                border: 1px solid rgba($ypo-cta, 0.7);
            }
        }

        .v-messages {
            display: none;
        }
    }
</style>
